import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
import MediaContent from "../media-content/MediaContent";
const useStyles = makeStyles(theme => ({
  container: {
    ...theme.grid.gridTemplateContainer,
    gridTemplateAreas: `"media"
                            "text"`,
    textAlign: "center",
    minWidth: 100,
    paddingTop: 5,
    gap: "20px 0px"
  },
  mediaContainer: {
    display: "flex",
    justifyContent: "flex-start",
    gridArea: "media"
  },
  textContainer: {
    gridArea: "text"
  },
  textContent: {
    whiteSpace: "pre-line",
    overflowWrap: "break-word"
  },
  [theme.breakpoints.up("sm")]: {
    container: {
      gridTemplateAreas: `
                                "text media"
                                `,
      gridTemplateColumns: "1fr 1fr",
      columnGap: 24,
      textAlign: "left"
    }
  },
  [theme.breakpoints.down("sm")]: {
    mediaContainer: {
      justifyContent: "center"
    }
  }
}));
const TextWithMeadia = ({
  content,
  leftSpaceContainer,
  bottomSpaceContainer = "",
  subHeaderContainer
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Grid, {
    className: `${leftSpaceContainer} ${classes.container} ${bottomSpaceContainer}`
  }, /*#__PURE__*/React.createElement(Grid, {
    className: `${subHeaderContainer} ${classes.textContainer}`
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textPrimary",
    className: classes.textContent
  }, content.text)), /*#__PURE__*/React.createElement(Grid, {
    className: classes.mediaContainer
  }, /*#__PURE__*/React.createElement(MediaContent, {
    content: content,
    noImageUrl: content.images[0].url === ""
  })));
};
TextWithMeadia.propTypes = {
  content: PropTypes.object.isRequired,
  leftSpaceContainer: PropTypes.string,
  bottomSpaceContainer: PropTypes.string,
  subHeaderContainer: PropTypes.string
};
export default TextWithMeadia;